import { createFileRoute } from '@tanstack/react-router';
import { TypesPage } from '../../types/TypesPage.js';

export const Route = createFileRoute('/types/')({ component: TypesRoute });

function TypesRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  return <TypesPage me={me} />;
}
